import { Component, OnInit  } from '@angular/core';

import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app',
  template: '<router-outlet></router-outlet>',
})

export class FramingRootComponent implements OnInit {
  constructor(
    private msal: MsalService,
    private msalBroadcast: MsalBroadcastService
  ) {}

  ngOnInit(): void {
    // Process any redirect response (#code=...) on startup
    //Application will be redirected and reloaded, this helps MSAL to acquire Entra ID information.
    this.msal.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult | null) => {
        if (result?.account && !this.msal.instance.getActiveAccount()) {
          this.msal.instance.setActiveAccount(result.account);
        }
      },
      error: (err) => console.error('MSAL redirect handling error:', err),
    });

    // Wait until MSAL startup finishes before making protected calls
    this.msalBroadcast.inProgress$
      .pipe(filter((s) => s === InteractionStatus.None))
      .subscribe(() => {
        // MSAL is ready
      });
  }
}

